import request from '@wearetla/tla-essentials-tools/utilities/request';
import { createI18nInstance } from '/utilities/i18n';

const getT = () => createI18nInstance().t;

const branchServices = {
	getBranch: (branchSlug) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get(`client/branch/${branchSlug}`, {}, (payload, status, request) => {
				if (payload?.client_branch) {
					resolve(payload.client_branch);
				} else {
					reject(request?.data?.meta?.messages || t('Şube getirilirken bir hata ile karşılaşıldı.'));
				}
			});
		});
	},
};

export default branchServices;
